import { StudentIdeBody } from "../student-ide/StudentIdeBody";

const DEFAULT_MAIN_PY = `# Sandbox: try Python in the browser.
print("Hello from Code Create Slay!")

name = input("What's your name? ")
print(f"Nice to meet you, {name}!")
`;

const STORAGE_KEY = "ccs-teacher-sandbox-main-py";

/** Local demo IDE for teachers after trial expiry (no curriculum APIs). */
export default function TeacherSandboxPage() {
  return (
    <StudentIdeBody
      eyebrow="Teacher · Sandbox"
      title="Browser IDE"
      backTo="/teacher/billing"
      backLabel="Billing"
      initialMainPy={DEFAULT_MAIN_PY}
      storageKey={STORAGE_KEY}
    />
  );
}
